import { styled } from '@egoist/vue-emotion'
import NerospecOriginLogo from '@/assets/logos/logo_nerospec_dark.svg'
import GHHOriginLogo from '@/assets/logos/logo_ghh_dark.svg'
import GSESOriginLogo from '@/assets/logos/logo_gses_dark.svg'
import SQOriginLogo from '@/assets/logos/logo_sq_dark.svg'
import FusionLogoDark from '@/assets/logos/fusion_logo_dark.svg'
import FusionLogoLight from '@/assets/logos/fusion_logo_light.svg'
import FusionLogoMobileDark from '@/assets/logos/fusion_logo_mobile_dark.svg'
import FusionLogoMobileLight from '@/assets/logos/fusion_logo_mobile_light.svg'
import SMAGLogoMobile from '@/assets/logos/logo_smag_mobile.svg'
import SMAGLogoDesktop from '@/assets/logos/logo_smag.svg'
import EYELogoMobile from '@/assets/logos/logo_eye_mobile.svg'
import EYELogoDesktop from '@/assets/logos/logo_eye.svg'
import RoeslerLogoMobile from '@/assets/logos/logo_roesler_mobile.svg'
import RoeslerLogoDarkDesktop from '@/assets/logos/logo_roesler_dark.svg'
import RoeslerLogoLightDesktop from '@/assets/logos/logo_roesler_light.svg'
import WeycorLogo from '@/assets/logos/weycor_logo.svg'

const GHHLightLogo = styled(GHHOriginLogo)`
  width: 100px;
  path {
    transition: fill 1s linear;
  }
`

const GHHDarkLogo = styled(GHHOriginLogo)`
  width: 100px;
  path {
    fill: white;
    transition: fill 1s linear;
  }
`

const GHHDarkLogoMobile = styled(GHHDarkLogo)`
  width: 45px;
`
const GHHLightLogoMobile = styled(GHHLightLogo)`
  width: 45px;
`

const NerospecLightLogo = styled(NerospecOriginLogo)`
  width: 100px;
  path {
    transition: fill 1s linear;
  }
`

const NerospecDarkLogo = styled(NerospecOriginLogo)`
  width: 100px;
  path {
    fill: white;
    transition: fill 1s linear;
  }
`

const NerospecDarkLogoMobile = styled(NerospecDarkLogo)`
  width: 45px;
`
const NerospecLightLogoMobile = styled(NerospecLightLogo)`
  width: 45px;
`

const GSESLightLogo = styled(GSESOriginLogo)`
  width: 45px;
  path {
    transition: fill 1s linear;
  }
`
const GSESDarkLogo = styled(GSESOriginLogo)`
  width: 45px;
  path {
    fill: white;
    transition: fill 1s linear;
  }
`
const GSESDarkLogoMobile = styled(GSESDarkLogo)`
  width: 45px;
`
const GSESLightLogoMobile = styled(GSESLightLogo)`
  width: 45px;
`

const SQLightLogo = styled(SQOriginLogo)`
  width: 110px;
  path {
    transition: fill 1s linear;
  }
`
const SQDarkLogo = styled(SQOriginLogo)`
  width: 110px;
  path {
    fill: white;
    transition: fill 1s linear;
  }
`
const SQDarkLogoMobile = styled(SQDarkLogo)`
  width: 45px;
`
const SQLightLogoMobile = styled(SQLightLogo)`
  width: 45px;
`
const RoeslerMobile = styled(RoeslerLogoMobile)`
  width: 45px;
  height: 45px;
  fill: transparent;
`
const WeycorLightLogo = styled(WeycorLogo)`
  width: 100px;
  path {
    transition: fill 1s linear;
  }
`

const WeycorDarkLogo = styled(WeycorLogo)`
  width: 100px;
  path {
    fill: white;
    transition: fill 1s linear;
  }
`

const WeycorDarkLogoMobile = styled(WeycorDarkLogo)`
  width: 45px;
`
const WeycorLightLogoMobile = styled(WeycorLightLogo)`
  width: 45px;
`

export default [
  {
    organizations: ['GSES'],
    dark: {
      desktop: GSESDarkLogo,
      mobile: GSESDarkLogoMobile,
    },
    light: {
      desktop: GSESLightLogo,
      mobile: GSESLightLogoMobile,
    },
  },
  {
    organizations: ['K+S', 'UMMC', 'GHH'],
    dark: {
      desktop: GHHDarkLogo,
      mobile: GHHDarkLogoMobile,
    },
    light: {
      desktop: GHHLightLogo,
      mobile: GHHLightLogoMobile,
    },
  },
  {
    organizations: ['nerospecSK'],
    dark: {
      desktop: NerospecDarkLogo,
      mobile: NerospecDarkLogoMobile,
    },
    light: {
      desktop: NerospecLightLogo,
      mobile: NerospecLightLogoMobile,
    },
  },
  {
    organizations: ['BAG', 'Pescher'],
    dark: {
      desktop: SQDarkLogo,
      mobile: SQDarkLogoMobile,
    },
    light: {
      desktop: SQLightLogo,
      mobile: SQLightLogoMobile,
    },
  },
  {
    organizations: ['DeutzDays'],
    dark: {
      desktop: FusionLogoDark,
      mobile: FusionLogoMobileDark,
    },
    light: {
      desktop: FusionLogoLight,
      mobile: FusionLogoMobileLight,
    },
  },
  {
    organizations: ['SMAG'],
    dark: {
      desktop: SMAGLogoDesktop,
      mobile: SMAGLogoMobile,
    },
    light: {
      desktop: SMAGLogoDesktop,
      mobile: SMAGLogoMobile,
    },
  },
  {
    organizations: ['EYE', 'MCO'],
    dark: {
      desktop: EYELogoDesktop,
      mobile: EYELogoMobile,
    },
    light: {
      desktop: EYELogoDesktop,
      mobile: EYELogoMobile,
    },
  },
  {
    organizations: ['Rösler'],
    dark: {
      desktop: RoeslerLogoDarkDesktop,
      mobile: RoeslerMobile,
    },
    light: {
      desktop: RoeslerLogoLightDesktop,
      mobile: RoeslerMobile,
    },
  },
  {
    organizations: ['Weycor'],
    dark: {
      desktop: WeycorDarkLogo,
      mobile: WeycorDarkLogoMobile,
    },
    light: {
      desktop: WeycorLightLogo,
      mobile: WeycorLightLogoMobile,
    },
  },
]
